<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div :style="{
  width: width+'px',height: height+'px',fontSize: fontSize+'px',
  borderWidth: border+'px',borderRadius: (height/3)+'px'
  }" class="credit-bar">
    <div :style="{width: ((width-(border*2))*max/max)+'px',height: (height-(border*2))+'px',}"
         class="external bar">
      <div :style="{paddingTop:((height-(border*2)-fontSize)/2)+'px',width: (width-(border*2))+'px',height: (height-(border*2))+'px'}"
           class="internal bar">
        {{ $helper.number_format(current, 0, 0) }}
        / {{ $helper.number_format(max, 0, 0) }}
      </div>
    </div>
    <div :style="{width: ((width-(border*2))*current/max)+'px',height: (height-(border*2))+'px',}"
         class="external bar gray-bar">
      <div :style="{paddingTop:((height-(border*2)-fontSize)/2)+'px',width: (width-(border*2))+'px',height: (height-(border*2))+'px'}"
           class="internal bar">
        {{ $helper.number_format(current, 0, 0) }}
        / {{ $helper.number_format(max, 0, 0) }}
      </div>
    </div>
    <div :style="{width: ((width-(border*2))*(prop_red+prop_green+prop_blue)/max)+'px',height: (height-(border*2))+'px',}"
         class="external bar blue-bar">
      <div :style="{paddingTop:((height-(border*2)-fontSize)/2)+'px',width: (width-(border*2))+'px',height: (height-(border*2))+'px'}"
           class="internal bar">
        {{ $helper.number_format(current, 0, 0) }}
        / {{ $helper.number_format(max, 0, 0) }}
      </div>
    </div>
    <div :style="{width: ((width-(border*2))*(prop_red+prop_green)/max)+'px',height: (height-(border*2))+'px',}"
         class="external bar green-bar">
      <div :style="{paddingTop:((height-(border*2)-fontSize)/2)+'px',width: (width-(border*2))+'px',height: (height-(border*2))+'px'}"
           class="internal bar">
        {{ $helper.number_format(current, 0, 0) }}
        / {{ $helper.number_format(max, 0, 0) }}
      </div>
    </div>
    <div :style="{width: ((width-(border*2))*(prop_red)/max)+'px',height: (height-(border*2))+'px',}"
         class="external bar red-bar">
      <div :style="{paddingTop:((height-(border*2)-fontSize)/2)+'px',width: (width-(border*2))+'px',height: (height-(border*2))+'px'}"
           class="internal bar">
        {{ $helper.number_format(current, 0, 0) }}
        / {{ $helper.number_format(max, 0, 0) }}
      </div>
    </div>
  </div>

</template>
<style lang="scss" scoped>
.credit-bar {
  display: block;
  background: #EEEEEE;
  border: solid 4px #000000;
  color: #666666;
  border-radius: 16px;
  text-align: center;

  position: relative;
  overflow: hidden;

  .bar {
    display: block;
    position: absolute;
    top: 0;
  }

  .external {
    overflow: hidden;

  }

  .internal {
    line-height: 1;
  }

  .gray-bar {
    background: #424242;
    color: #FFFFFF;
  }

  .red-bar {
    background: #F44336;
    color: #FFFFFF;
  }

  .green-bar {
    background: #4CAF50;
    color: #FFFFFF;
  }

  .blue-bar {
    background: #03A9F4;
    color: #FFFFFF;
  }

}

.theme--light .credit-bar {
  border: solid 4px #000000;
}

.theme--dark .credit-bar {
  border: solid 4px #FFFFFF;
  background: #CCCCCC;
}

</style>

<script lang="ts">

import {Component, Prop, Vue} from 'vue-property-decorator'


@Component({
  components: {},
})
export default class CreditBar extends Vue {
  @Prop() width: number
  @Prop() height: number
  @Prop() fontSize: number
  @Prop() max: number
  @Prop() current: number
  @Prop({default: 4}) border: number

  @Prop() prop_red: number
  @Prop() prop_green: number
  @Prop() prop_blue: number


}

</script>
